'use strict';

import timestamper from 'incidents/utils/timestamps';


export class State {
	constructor(name, query, options) {
		this.name = name;
		this.query = query;
	}
}


export default class StateDiagram {
	constructor(customTimestamper) {
		this.states = [];
		this.timestamper = customTimestamper || new timestamper();
	}

	add(name, query, stateOptions) {
		this.states.unshift(new State(name, query, stateOptions));
		return this;
	}

	updateIncident(incident) {
		this.timestamper.timestampIncident(incident);

		// This bit of code ensures that the incident is considered "new" until it
		// is acknowledged.  There is a minor correct for the JCW Bupp.
		const acknowledgementEvents = [
			'acknowledged',
			'team:leader_assigned',
		];
		let incidentAcknowledged = false;
		for (let event of acknowledgementEvents) {
			if (incident.timestamps[event]) {
				incidentAcknowledged = true;
				break;
			}
		}
		if (!incidentAcknowledged) {
			incident.state = 'new';
			incident.stateTime = incident.time;
			return;
		}

		for (let stateName of ['completed', 'archived']) {
			if (incident[stateName]) {
				incident.state = stateName;
				incident.stateTime = new Date();
				return;
			}
		}
		for (let state of this.states) {
			let entry = state.query(incident);
			if (entry) {
				incident.state = state.name;
				incident.stateTime = entry.time;
				incident.stateEvent = entry;
				return;
			}
		}
		incident.state = 'new';
		incident.stateTime = incident.time;
	}
}
